import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import OpportunityCard from "@/components/OpportunityCard";
import { ShoppingBag } from "lucide-react";
import { LUXURY_IMAGES } from "@/lib/constants";

const STATES = ["", "CA", "TX", "FL", "NY", "IL", "PA", "OH", "GA", "NC", "MI", "WA", "AZ"];

export default function MarketplacePage() {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({ state: "", q: "", max_price: "" });

  useEffect(() => {
    const p = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v) p.set(k, v); });
    api.get(`/marketplace/equipment?${p.toString()}`).then((r) => setItems(r.data.items || []));
  }, [filters]);

  return (
    <div className="space-y-5" data-testid="marketplace-page">
      <div className="relative rounded-lg overflow-hidden border border-[#33291f]">
        <img src={LUXURY_IMAGES[2]} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#14100c] via-[#14100c]/85 to-[#14100c]/40" />
        <div className="relative p-6">
          <div className="flex items-center gap-2 mb-2">
            <ShoppingBag size={14} className="text-[#d4a574]" />
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#d4a574] font-semibold">Equipment Marketplace</div>
          </div>
          <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">Buy business equipment & auction assets.</h1>
        </div>
      </div>

      <div className="border border-[#33291f] rounded-lg p-4 bg-[#1c1712] grid grid-cols-2 md:grid-cols-4 gap-3">
        <Input placeholder="Search…" value={filters.q} onChange={(e) => setFilters({ ...filters, q: e.target.value })} data-testid="mkt-q" className="bg-[#241d16] border-[#33291f]" />
        <Select value={filters.state || "all"} onValueChange={(v) => setFilters({ ...filters, state: v === "all" ? "" : v })}>
          <SelectTrigger data-testid="mkt-state" className="bg-[#241d16] border-[#33291f]"><SelectValue placeholder="State" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All States</SelectItem>
            {STATES.filter(Boolean).map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
        <Input placeholder="Max price ($)" type="number" value={filters.max_price} onChange={(e) => setFilters({ ...filters, max_price: e.target.value })} data-testid="mkt-max-price" className="bg-[#241d16] border-[#33291f]" />
      </div>

      <div className="text-[11px] text-[#7a6d5a]">{items.length} listings</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {items.map((o) => <OpportunityCard key={o.id} opp={o} />)}
      </div>
      {items.length === 0 && <div className="text-center py-16 text-[#7a6d5a]">No equipment listings match your filters.</div>}
    </div>
  );
}
